import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";
import api from "../lib/api";
import { Button } from "../components/ui/button";

export default function Verify() {
  const { t } = useI18n();
  const [sp] = useSearchParams();
  const [status, setStatus] = useState("loading"); // loading | success | error
  const token = sp.get("token");

  useEffect(() => {
    if (!token) { setStatus("error"); return; }
    api.get("/auth/verify", { params: { token } })
      .then(() => setStatus("success"))
      .catch(() => setStatus("error"));
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-gradient-to-br from-[#F8FAF9] to-teal-50">
      <div className="w-full max-w-sm bg-white rounded-3xl border border-slate-200 shadow-xl p-8 text-center cm-fade-up">
        <Link to="/" className="flex items-center justify-center mb-6">
          <img src="/logo.png" alt="CANARIAS MARKET" className="h-16 w-auto object-contain" />
        </Link>

        {status === "loading" && (
          <div data-testid="verify-loading">
            <Loader2 className="h-10 w-10 mx-auto text-[#008080] animate-spin" />
            <p className="text-slate-500 mt-4">{t("verify.verifying")}</p>
          </div>
        )}
        {status === "success" && (
          <div data-testid="verify-success">
            <span className="h-16 w-16 mx-auto grid place-items-center rounded-2xl bg-emerald-50 text-emerald-600 mb-4"><CheckCircle2 className="h-9 w-9" /></span>
            <h1 className="font-display font-bold text-2xl">{t("verify.success")}</h1>
            <p className="text-sm text-slate-500 mt-2">{t("verify.successDesc")}</p>
            <Link to="/auth"><Button data-testid="verify-go-login" className="w-full mt-6 h-11 bg-[#008080] hover:bg-[#006666]">{t("verify.goLogin")}</Button></Link>
          </div>
        )}
        {status === "error" && (
          <div data-testid="verify-error">
            <span className="h-16 w-16 mx-auto grid place-items-center rounded-2xl bg-rose-50 text-rose-600 mb-4"><XCircle className="h-9 w-9" /></span>
            <h1 className="font-display font-bold text-2xl">{t("verify.error")}</h1>
            <p className="text-sm text-slate-500 mt-2">{t("verify.errorDesc")}</p>
            <Link to="/auth"><Button variant="outline" className="w-full mt-6 h-11">{t("verify.goLogin")}</Button></Link>
          </div>
        )}
      </div>
    </div>
  );
}
